import { render, staticRenderFns } from "./KETAnmerkungen.vue?vue&type=template&id=db6865fa&"
import script from "./KETAnmerkungen.vue?vue&type=script&lang=js&"
export * from "./KETAnmerkungen.vue?vue&type=script&lang=js&"
import style0 from "./KETAnmerkungen.vue?vue&type=style&index=0&id=db6865fa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports